import React from 'react';
import PropTypes from 'prop-types';

const FacebookImage = ({ record = {}, source }) => (
  <img alt="" src={'https://graph.facebook.com/' + record[source] + '/picture?type=square'} />
);

FacebookImage.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default FacebookImage;



// WEBPACK FOOTER //
// ./src/resources/ui/FacebookImage.js